const ampmCasing = {
    lowercase: {
        true: 'pm',
        false: 'am',
    },
    uppercase: {
        true: 'PM',
        false: 'AM',
    },
};

export const formatHourInAMPMFormat = (ISOstring, ampmCase = 'lowercase') => {
    const dateFormatted = new Date(ISOstring);
    const hoursFromDate = dateFormatted.getHours();
    const minutesFromDate = dateFormatted.getMinutes();
    const ampm = ampmCasing[ampmCase][hoursFromDate >= 12];
    const standardHoursFormat = hoursFromDate % 12;
    let minutes =
        minutesFromDate < 10 ? `0${minutesFromDate}` : minutesFromDate;
    const hour = standardHoursFormat ? standardHoursFormat : 12;
    return minutes === '00' ? `${hour}${ampm}` : `${hour}:${minutes}${ampm}`;
};

export const formatMinuteFromISO = (ISOstring) => {};

export const getMonthFromISO = (ISOstring) => {
    const monthsArray = [
        'Jan.',
        'Feb.',
        'Mar.',
        'Apr.',
        'May',
        'Jun.',
        'Jul.',
        'Aug.',
        'Sept.',
        'Oct.',
        'Nov.',
        'Dec.',
    ];
    const dateFormatted = new Date(ISOstring);
    const month = dateFormatted.getMonth();
    return monthsArray[month];
};

export const getDateFromISO = (ISOstring) => {
    const dateFormatted = new Date(ISOstring);
    return dateFormatted.getDate();
};

export const getNumerizedMonthFromISO = (ISOstring) => {
    const dateFormatted = new Date(ISOstring);
    const month = dateFormatted.getMonth() + 1;

    return month;
};

export const getDayOfWeekFullNameFromISO = (ISOstring) => {
    const monthsArray = [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
    ];
    const dateFormatted = new Date(ISOstring);
    const dateNumber = dateFormatted.getDay();
    return monthsArray[dateNumber];
};

export const getUserLocalTimeZone = () => {
    const d = new Date();
    const timezone = d
        .toLocaleString('en', { timeZoneName: 'short' })
        .split(' ')
        .pop();

    // in ie11, toLocaleString doesn't return timezone
    // in windows safari 5, the time gets returned
    // so AM or PM or HH:MM:SS gets popped - return empty string
    const isAmPm = timezone === 'PM' || timezone === 'AM';
    const isTime = timezone.indexOf(':') !== -1;

    if (isAmPm || isTime) {
        return '';
    }

    return timezone;
};

export const getFourDigetYearFromISO = (ISOstring) => {
    const d = new Date(ISOstring);
    return d.getFullYear();
};

export const getFormattedTimestamp = (dateTime) => {
    const date = getMMDDYYTimestamp(dateTime);
    const time = formatHourInAMPMFormat(dateTime, 'uppercase');
    const timezone = getUserLocalTimeZone();

    return `${date} at ${time} ${timezone}`;
};

export const extendTimeToTwoDigit = (time) => {
    if (time < 10) {
        return `0${time}`;
    }

    return time;
};

export const getMMDDYYTimestamp = (dateTime, yearLength = 2) => {
    const month = extendTimeToTwoDigit(getNumerizedMonthFromISO(dateTime));
    const date = extendTimeToTwoDigit(getDateFromISO(dateTime));
    const year = getFourDigetYearFromISO(dateTime)
        .toString()
        .substr(yearLength);

    return `${month}/${date}/${year}`;
};

export const generateYearsArray = (startYearRange = 60, endYearRange = 0) => {
    const years = [];
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - startYearRange;
    const endYear = currentYear + endYearRange;
    for (let year = startYear; year <= endYear; year++) {
        years.push(year);
    }
    return years;
};
